import React from 'react';

interface IProps {
  children: React.ReactNode;
}

const TabBody: React.FC<IProps> = ({ children }) => {
  return <div className='tab-body'>{children}</div>;
};

export default TabBody;
